module.exports = "../study/imgs/maps/Nagano/S8/Climate/Temperture/Nagano_Temperture_MRI_RCP26_End.png";